import {
  Text,
  TwSelector as Selector,
  Button,
  Icon,
  Chip,
  Dialog,
} from "@ui-component-library";

import { usePropsDataStore } from '@store/PropsDataStore';

export default function SelectPropertyDialog({
  isOpen,
  onClose,
  userProperties,
  selectedProperties,
  onSelect,
}) {
  const { props } = usePropsDataStore();
  const isOptionDisabled = (option) => option.type !== "PROP" || option.dfr;
  const isPlusProperties = (option)  => option.dfr;
  const isEmpty = !userProperties?.length;


  const propOptions = Window.react_data?.owned_props;

  props.forEach((p) => {
    const exists = propOptions.some((p2) => p2.ref == p.ref);
    if(!exists){
      propOptions.push(p)
    }
  })

  return (
    <Dialog isOpen={isOpen} size="medium">
      <Dialog.Header>
        <div className="flex w-full justify-between">
          <Text variant="text-base/leading-normal/medium">
            Välj fastighet
          </Text>
          <Button
            tw
            variant="secondary"
            size="icon"
            onClick={onClose}
          >
            <Icon
              tw
              name="CrossSimple"
              className="color-charcoal-500"
              size="medium"
            />
          </Button>
        </div>
      </Dialog.Header>
      <Dialog.Content>
        {isEmpty ? (
          <div className="flex flex-col gap-2">
            <Text
              variant="text-sm/leading-normal/semibold"
              className="text-danger-500"
            >
              Du har inga fastigheter på ditt konto.
            </Text>
            <Text variant="text-sm/leading-normal/normal">
              Stäng köp rutan och klicka på 'Karta' i menyn, sedan 'Lägg till
              fastighet' högst upp på sidan.
            </Text>
          </div>
        ) : (
          <Selector>
            {propOptions.map((option) => (
              <div
                key={option.ref}
                className="flex flex-row gap-1 justify-between items-center relative"
              >
                <Selector.Option
                  label={option.designation?.toLowerCase()}
                  value={option.ref}
                  isSelected={selectedProperties?.some(
                    (p) => p.ref === option.ref
                  )}
                  onClick={onSelect}
                  disabled={isOptionDisabled(option)}
                  className="capitalize"
                />
                {isPlusProperties(option) && (
                  <div className="bg-[#F6F5FE] flex flex-row gap-1 items-center rounded-md p-4 cursor-not-allowed">
                    <Icon
                      tw
                      name="SparkleSimple"
                      size="medium"
                      className="fill-[#6856C3]"
                    />
                    <Text variant="text-sm/leading-normal/medium" className="text-[#6856C3]">Plus</Text>
                  </div>
                )}
              </div>
            ))}
          </Selector>
        )}
      </Dialog.Content>
      <Dialog.Footer>
        <Button
          tw
          variant="primary"
          onClick={onClose}
        >
          Klar
        </Button>
      </Dialog.Footer>
    </Dialog>
  );
}
